<template>
  <div>
    <List v-if="activeName == 'list'"></List>
    <!-- <Grade v-if="activeName == 'grade'"></Grade> -->
    <Apply v-if="activeName == 'apply'"></Apply>
  </div>
</template>
<script>
import bus from "@/utils/eventBus.js";
import PlusApi from "@/api/plus.js";
import List from "./list/index";
import Grade from "./grade/index";
import Apply from "./apply/index";


export default {
  components: {
    List,
    Grade,
    Apply
  },
  data() {
    return {
  
      formInline: {
        nick_name: ""
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: "list",
      /*切换数组*/
      sourceList: [
        {
          key: "list",
          value: "推广员列表",
          path: "/promotion/promotion/list/index"
        },
        {
          key: "apply",
          value: "推广申请",
          path: "/promotion/promotion/apply/index"
        }
        // {
        //   key: "grade",
        //   value: "推广等级",
        //   path: "/promotion/promotion/grade/index"
        // }
      ],
      /*权限筛选后的数据*/
      tabList: [],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch: {
    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  created() {
    this.init();
  
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit("tabData", { active: null, tab_type: "promotion", list: [] });
    bus.$off("activeValue");
  },
  methods: {
   

    /*初始化方法*/
    init() {
      this.tabList = this.authFilter();

      if (this.tabList.length > 0) {
        this.activeName = this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on("activeValue", res => {
        if (this.is_third_param) {
          this.param.user_id = "";
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type: "promotion"
      };
      bus.$emit("tabData", params);
    },

    /*权限过滤*/
    authFilter() {
      let list = [];
      for (let i = 0; i < this.sourceList.length; i++) {
        let item = this.sourceList[i];
        if (this.$filter.isAuth(item.path)) {
          list.push(item);
        }
      }
      console.log(list, "999");
      return list;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/promotion/promotion/index.vue